import { CoreIcon } from '../core-icon';
import dashboardSVG from '../../assets/icons/dashboard.svg';
import type { IconProps } from '../core-icon';

export const DashboardIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={dashboardSVG} {...props} />;
};
